// @flow
import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { connect } from 'react-redux';
import bindAll from 'lodash/bindAll';
import * as actions from "../../modules/actions";
import { Tooltip } from '../';
import SidebarWidget  from '../SidebarWidget';
import SortDown from '../Icons/SortDown';
import colors from '../../assets/css/colors';

const WaiverLine = styled.li`
	display: flex;
	align-items: center;
	margin: 1em 0;
`;

const WaiverIndex = styled.div`
	font-size: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	font-weight: bold;
	height: 20px;
	width: 20px;
	border-radius: 50%;
	background: ${colors.lightGreen};
	color: ${colors.nrlDarkGreen};
	margin-right: 10px;
`;

const TeamName = styled.p`
	color: ${colors.nrlDarkGreen};
	font-size: 12px;
	font-weight: bold;
	margin-bottom: 5px;
`;

const UserName = styled.p`
	font-size: 12px;
	color: ${colors.darkGrey};
`;

const TooltipText = styled.div`
	text-align: left;
	li {
		margin-top: 5px;
	}
`;

type Props = {
	league_id: number,
	fetchWaiverOrder: Function,
	rfa_ids: Array<number>,
	rfa_teams: Object,
	onToggle: Function,
	widget_open: boolean
};

class WaiverOrderWidgetComponent extends React.Component<Props> {
	constructor(props: Props, state: Object) {
		super(props, state);

		bindAll(this, [
			'getTeam'
		]);
	}
	componentDidMount() {
		const { league_id, fetchWaiverOrder } = this.props;

		fetchWaiverOrder({
			league_id
		});
	}

	getTeam(id: number, index: number) {
		const { rfa_teams } = this.props;
		const team = rfa_teams[id];

		return (
			<WaiverLine key={id}>
				<WaiverIndex>
					{index + 1}
				</WaiverIndex>
				<div>
					<TeamName>
						{team.name}
					</TeamName>
					<UserName>
						{team.firstname}
					</UserName>
				</div>
			</WaiverLine>
		);
	}

	get tooltip_text() {
		return (
			<TooltipText>
				<p>
					Displays your leagues current restricted free agent priority order.
					Depending on your league settings this will either update by
				</p>
				<ul>
					<li>
						- Reverse the ladder i.e. The Team that is positioned
						last on the ladder gets the first selection.
					</li>
					<li>
						- Last Pick to Bottom, rolling updates when a user claims a
						restricted free agent, they will then be sent to the bottom of the order.
					</li>
				</ul>
			</TooltipText>
		);
	}

	render() {
		const { rfa_ids } = this.props;
		return (
			<SidebarWidget
				icon={<SortDown />}
				title="RFA Order"
				widget_open={this.props.widget_open}
				onToggle={this.props.onToggle}
				rightIcon={<Tooltip
					show_on_left={true}
					title={'Restricted Free Agent Order'}
					children={this.tooltip_text}
				/>
				}
			>
				{_.isEmpty(rfa_ids) ? <p>This league does not have RFAs</p> :
					<ul>
						{rfa_ids.map(this.getTeam)}
					</ul>}
			</SidebarWidget>
		);
	}
}

const mapStateToProps = state => ({
	rfa_ids: state.leagues.waiver_order.ordered_ids,
	rfa_teams: state.leagues.waiver_order.by_id
});

const mapDispatchToProps = {
	fetchWaiverOrder: actions.leagueDraft.fetchWaiverOrder,
};

export const WaiverOrderWidget = connect(
	mapStateToProps,
	mapDispatchToProps,
)(WaiverOrderWidgetComponent);

export default WaiverOrderWidget;


// WEBPACK FOOTER //
// ./src/components/WaiverOrderWidget/index.js